import {Button, Group, Modal, Stack, Text, TextInput} from '@mantine/core'

import type {DriverLink} from './schemas'

export function DriverLinkDialog({link, onClose}: {link: DriverLink | null; onClose: () => void}) {
    return (
        <Modal opened={link != null} onClose={onClose} title="Driver link">
            <Stack gap="sm">
                <Text size="sm">
                    Could not copy the link. Copy it below and send it only to {link?.workerName}.
                </Text>
                <TextInput
                    label={`Link for ${link?.workerName ?? 'the driver'}`}
                    value={link?.url ?? ''}
                    readOnly
                    autoFocus
                    onFocus={(event) => event.currentTarget.select()}
                />
                <Group justify="flex-end">
                    <Button onClick={onClose}>Done</Button>
                </Group>
            </Stack>
        </Modal>
    )
}
